<template>
    <!-- the shooting of one line of stats: the percentages and where the points came from -->
    <div class="shot-summary">
        <div class="shot-summary__tiles">
            <div v-for="tile in tiles" :key="tile.code" class="shot-summary__tile" :class="{ 'shot-summary__tile--lead': tile.code === 'FG' }">
                <span class="shot-summary__pct">{{ tile.att ? tile.pct : '–' }}<small v-if="tile.att">%</small></span>
                <span class="shot-summary__code">{{ tile.code }}</span>
                <span class="shot-summary__ratio">{{ tile.made }}/{{ tile.att }}</span>
            </div>
        </div>

        <div v-if="points.total" class="shot-summary__split">
            <div class="shot-summary__bar">
                <span v-for="part in points.parts" :key="part.code" :class="`shot-summary__part--${part.code}`" :style="{ width: `${part.share}%` }" />
            </div>
            <div class="shot-summary__legend">
                <span v-for="part in points.parts" :key="part.code">
                    <i :class="`shot-summary__part--${part.code}`" />{{ part.label }} <b>{{ part.points }}</b>
                </span>
                <span class="shot-summary__total"><b>{{ points.total }}</b> πόντοι</span>
            </div>
        </div>
    </div>
</template>

<script>
    const num = value => Number(value) || 0

    export default {
        props: {
            // a line of stats: twoPointsMade, twoPointAttempts, threePointsMade, ...
            stat: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            tiles() {
                const s = this.stat || {}
                const tile = (code, made, att) => ({ code, made, att, pct: att ? Math.round(made / att * 100) : 0 })
                return [
                    tile('FG', num(s.twoPointsMade) + num(s.threePointsMade), num(s.twoPointAttempts) + num(s.threePointAttempts)),
                    tile('2P', num(s.twoPointsMade), num(s.twoPointAttempts)),
                    tile('3P', num(s.threePointsMade), num(s.threePointAttempts)),
                    tile('FT', num(s.freeThrowsMade), num(s.freeThrowAttempts))
                ]
            },
            points() {
                const s = this.stat || {}
                const parts = [
                    { code: 'two', label: '2P', points: num(s.twoPointsMade) * 2 },
                    { code: 'three', label: '3P', points: num(s.threePointsMade) * 3 },
                    { code: 'ft', label: 'Βολές', points: num(s.freeThrowsMade) }
                ]
                const total = parts.reduce((sum, part) => sum + part.points, 0)
                return { total, parts: parts.map(part => ({ ...part, share: total ? Math.round(part.points / total * 100) : 0 })) }
            }
        }
    }
</script>

<style scoped>
.shot-summary {
    font-family: Roboto, Arial, sans-serif;
}

.shot-summary__tiles {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 6px;
}

.shot-summary__tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6px 2px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.shot-summary__tile--lead {
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    border-color: transparent;
}

.shot-summary__pct {
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 1.35rem;
    line-height: 1;
}

.shot-summary__pct small {
    font-size: 0.75rem;
}

.shot-summary__code {
    font-size: 0.62rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    color: #03e5b7;
}

.shot-summary__tile--lead .shot-summary__code {
    color: #fff;
}

.shot-summary__ratio {
    font-size: 0.66rem;
    color: rgba(255, 255, 255, 0.55);
}

.shot-summary__tile--lead .shot-summary__ratio {
    color: rgba(255, 255, 255, 0.85);
}

.shot-summary__split {
    margin-top: 10px;
}

.shot-summary__bar {
    display: flex;
    height: 6px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    overflow: hidden;
}

.shot-summary__legend {
    display: flex;
    flex-wrap: wrap;
    gap: 2px 10px;
    margin-top: 5px;
    font-size: 0.68rem;
    color: rgba(255, 255, 255, 0.6);
}

.shot-summary__legend span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.shot-summary__legend b {
    color: #fff;
}

.shot-summary__legend i {
    width: 7px;
    height: 7px;
    border-radius: 2px;
}

.shot-summary__total {
    margin-left: auto;
}

.shot-summary__part--two {
    background: #03e5b7;
}

.shot-summary__part--three {
    background: #037ade;
}

.shot-summary__part--ft {
    background: #ffc107;
}
</style>
